<template>
  <b-row>
    <b-col sm="12">
      <b-card :title = "metadata.label">
        <b-table striped hover :items="ifrm_table" :fields="fields">
          <template slot="bottom-row" :slot-scope="'data'">
            <td align="right" ><strong>Nivel de Afectación:</strong></td><td :style="bgcolor" ><strong>{{nivel_afectacion}}</strong></td>
            <td colspan="2" align="right" ><strong>IFRM</strong></td><td><strong>{{ifrm.ifrm_value}}</strong></td>
          </template>
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import { mapState } from 'vuex'

const O1 = 1
const O2 = 2
const O3 = 3
const O4 = 4
const EVALUATION_TABLES = {
  'soil_type': {},
  'floor_slope': {
    [O1]: { [O1]: 10, [O2]: 20, [O3]: 20, [O4]: 30 }, // suave
    [O2]: { [O1]: 20, [O2]: 30, [O3]: 30, [O4]: 40 }, // moderada
    [O3]: { [O1]: 30, [O2]: 40, [O3]: 40, [O4]: 50 }, // escarpada
    [O4]: { [O1]: 40, [O2]: 50, [O3]: 50, [O4]: 50 } // muy escarpada
  },
  'vegetation_cover': { [O1]: 0, [O2]: 20, [O3]: 40, [O4]: 50 },
  'water_presence': { [O1]: 0, [O2]: 20, [O3]: 40, [O4]: 50 },
  'rainfall': { [O1]: 15, [O2]: 30, [O3]: 40, [O4]: 50 },
  'containment_works': { [O1]: 0, [O2]: 20, [O3]: 40, [O4]: 50 },
  'erosion_control_works': { [O1]: 0, [O2]: 20, [O3]: 40, [O4]: 50 },
  'hold_point': { [O1]: 50, [O2]: 0 },
  'pipeline_affectation': {
    [O1]: { 0: 10, 100: 20, 200: 30, 300: 30 }, // >12m
    [O2]: { 0: 20, 100: 30, 200: 40, 300: 40 }, // 5 a 12m
    [O3]: { 0: 30, 100: 40, 200: 40, 300: 50 }, // <5m
    [O4]: { 0: 50, 100: 50, 200: 50, 300: 50 } // ducto expuesto
  },
  'movement_stage': { [O1]: 0, [O2]: 30, [O3]: 40, [O4]: 50 }
}
const EVALUATION_PERCENTAGES = {
  'soil_type': 0,
  'floor_slope': 0.15,
  'vegetation_cover': 0.05,
  'water_presence': 0.05,
  'rainfall': 0.10,
  'containment_works': 0.15,
  'erosion_control_works': 0.15,
  'hold_point': 0.05,
  'pipeline_affectation': 0.25,
  'movement_stage': 0.05
}

export default {
  name: 'FormComponentIFRM',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  mounted () {
    this.calculate()
  },
  data () {
    return {
      ifrm: { 'ifrm_value': 0, 'ifrm_table': {} },
      fields: [
        {
          key: 'variable',
          label: 'Variable',
          sortable: true
        },
        {
          key: 'evaluacion',
          label: 'Evaluación',
          sortable: true
        },
        {
          key: 'porcentaje',
          label: '%',
          sortable: true
        },
        {
          key: 'valor',
          label: 'V',
          sortable: true
        },
        {
          key: 'ponderacion',
          label: 'Cn',
          sortable: true
        }
      ],
      ifrm_table: []
    }
  },
  computed: {
    ...mapState({
      'currmodel': 'currmodel',
      'metadatax': 'metadata'
    }),
    evaluation () {
      if ('evaluation' in this.currmodel) {
        return this.currmodel.evaluation
      }
      return {}
    },
    landslide_afectation () {
      if ('landslide_afectation' in this.currmodel) {
        return this.currmodel.landslide_afectation
      }
      return {}
    },
    nivel_afectacion () {
      if (this.ifrm.ifrm_value <= 10) {
        return 'Muy Bajo'
      } else if (this.ifrm.ifrm_value <= 20) {
        return 'Bajo'
      } else if (this.ifrm.ifrm_value <= 32) {
        return 'Moderado'
      } else if (this.ifrm.ifrm_value <= 42) {
        return 'Moderadamente Alto'
      } else {
        return 'Alto'
      }
    },
    bgcolor () {
      if (this.ifrm.ifrm_value <= 10) {
        return 'background-color: rgb(0,176,80)'
      } else if (this.ifrm.ifrm_value <= 20) {
        return 'background-color: rgb(146,208,80)'
      } else if (this.ifrm.ifrm_value <= 32) {
        return 'background-color: rgb(255,255,0)'
      } else if (this.ifrm.ifrm_value <= 42) {
        return 'background-color: rgb(255,192,0)'
      } else {
        return 'background-color: rgb(255,0,0)'
      }
    }
  },
  watch: {
    value: function (val) {
      this.$emit('valuechange', val)
    },
    evaluation: {
      handler: function (val, oldVal) { this.calculate() },
      deep: true
    },
    landslide_afectation: function (val, oldVal) {
      this.calculate()
    }
  },
  methods: {
    calculate () {
      var resp = {}
      var ifrmValue = 0
      if (this.metadatax.evaluation) {
        for (var i in this.metadatax.evaluation.children) {
          if (i !== 'soil_type') {
            var field = this.metadatax.evaluation.children[i]
            var valuex = null
            if (this.currmodel && this.currmodel.evaluation &&
              i in this.currmodel.evaluation) {
              valuex = this.currmodel.evaluation[i]
            }
            var display = ''
            for (var j = 0; j < field.choices.length; j++) {
              if (valuex === field.choices[j].value) {
                display = field.choices[j].display_name
              }
            }
            if (valuex === null) {
              resp[i] = ([field.label, display, EVALUATION_PERCENTAGES[i], 0, 0])
            } else if (i === 'floor_slope') {
              if ('soil_type' in this.currmodel.evaluation) {
                var valuex2 = this.currmodel.evaluation['soil_type']
                resp[i] = ([field.label, display, EVALUATION_PERCENTAGES[i], EVALUATION_TABLES[i][valuex][valuex2], EVALUATION_TABLES[i][valuex][valuex2] * EVALUATION_PERCENTAGES[i]])
              } else {
                resp[i] = ([field.label, display, EVALUATION_PERCENTAGES[i], 0, 0])
              }
            } else if (i === 'pipeline_affectation') {
              var area = 1
              if ('landslide_afectation' in this.currmodel) {
                var length = parseFloat(this.currmodel.landslide_afectation.landslide_length) || 1
                var width = parseFloat(this.currmodel.landslide_afectation.landslide_width) || 1
                area = length * width
              }
              var evaluationValue = 0
              var keys = Object.keys(EVALUATION_TABLES[i][valuex])
              keys.sort(function (a, b) { return a - b })
              for (j = keys.length; j >= 0; j--) {
                if (area > keys[j]) {
                  evaluationValue = EVALUATION_TABLES[i][valuex][keys[j]]
                  break
                }
              }
              resp[i] = ([field.label, display, EVALUATION_PERCENTAGES[i], evaluationValue, evaluationValue * EVALUATION_PERCENTAGES[i]])
            } else {
              resp[i] = ([field.label, display, EVALUATION_PERCENTAGES[i], EVALUATION_TABLES[i][valuex], EVALUATION_TABLES[i][valuex] * EVALUATION_PERCENTAGES[i]])
            }
            ifrmValue += resp[i][4]
          }
        }
      }
      // console.log(resp)
      this.$set(this.ifrm, 'ifrm_table', resp)
      this.$set(this.ifrm, 'ifrm_value', ifrmValue)
      this.$set(this, 'ifrm_table', Object.keys(resp).map(function (key) {
        return { variable: resp[key][0], evaluacion: resp[key][1], porcentaje: resp[key][2], valor: resp[key][3], ponderacion: resp[key][4] }
      }))
      this.$emit('input', this.ifrm)
    }
  }
}
</script>
